import {Directive, Output, OnInit, EventEmitter, ElementRef, NgZone, HostListener} from '@angular/core';
import {Mascaras} from '../masks/mascaras';

@Directive({
    selector: '[telefone]'
})
export class TelefoneDirective {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);

  constructor(
    private _el: ElementRef,
    private _ngZone: NgZone) { }

    @HostListener('input') onKeyUp() {
      
    if(this._el.nativeElement.value)
    {        
        var newValue = this._el.nativeElement.value;
        
        newValue = Mascaras.telefone(newValue);

        this._ngZone.run(() =>
            this.ngModelChange.emit(newValue));
    }
  }

  ngOnInit() {

  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/directives/telefone.directive.ts
 **/